import React from 'react';

// Multi-step wizard progress dots. Active step renders as a wide pill;
// past steps are clickable to jump back; future steps are dimmed and
// disabled. Extracted from prototypes/campaign-creation-prototype.jsx
// lines 2750-2783 for use by CampaignForgeV2.
export const StepIndicator = ({ step, totalSteps, theme, onJump }) => {
  const c = theme.colors;
  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 6,
      padding: '10px 0',
    }}>
      {Array.from({ length: totalSteps }).map((_, i) => {
        const stepNum = i + 1;
        const isActive = stepNum === step;
        const isPast = stepNum < step;
        return (
          <button
            key={i}
            onClick={() => isPast && onJump && onJump(stepNum)}
            disabled={!isPast}
            title={`Step ${stepNum}`}
            aria-label={`Step ${stepNum}${isActive ? ' (current)' : isPast ? ' (completed)' : ''}`}
            style={{
              width: isActive ? 18 : 6,
              height: 6,
              borderRadius: 3,
              border: 'none',
              padding: 0,
              background: isActive ? c.accent : (isPast ? c.borderPrimary : c.borderLight),
              opacity: isActive || isPast ? 1 : 0.4,
              cursor: isPast ? 'pointer' : 'default',
              transition: 'all 200ms ease',
            }}
          />
        );
      })}
    </div>
  );
};
